"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDefaultIsReconnectDesiredFn = void 0;
function buildDefaultIsReconnectDesiredFn() {
    if (_isNode()) {
        return () => Promise.resolve(true);
    }
    if (!window || !window.navigator) {
        throw new Error('IsoConfused: not using Nodejs nor browser');
    }
    let hasFocus = true;
    window.addEventListener('blur', () => {
        hasFocus = false;
    });
    return () => __awaiter(this, void 0, void 0, function* () {
        if (!hasFocus) {
            yield new Promise(resolve => {
                const setFocusFn = () => {
                    hasFocus = true;
                    window.removeEventListener('focus', setFocusFn);
                    resolve(true);
                };
                window.addEventListener('focus', setFocusFn);
            });
        }
        return true;
    });
}
exports.buildDefaultIsReconnectDesiredFn = buildDefaultIsReconnectDesiredFn;
function _isNode() {
    return typeof process === 'object' &&
        typeof process.versions === 'object' &&
        !!process.versions.node;
}
//# sourceMappingURL=await-focus-browser-support.js.map